import React, { FC, Fragment, useState } from 'react';
import { Paper, Unstable_Grid2 as Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { GridLayoutSizes } from 'types/app';
import { ContentFragment } from 'api';
import { Dimensions } from 'components';
import { ContentProvider, DimensionsProvider } from 'providers';

import { ContentSection, ImageSection } from '../grid';
import { isTextOnly } from '../helpers';

interface Props {
  content: ContentFragment;
  variant: GridLayoutSizes;
}

const FeedGridItem: FC<Props> = ({ content, variant }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const [hovered, setHovered] = useState(false);

  function renderImageSection() {
    return (
      <Dimensions>
        {dimensions => (
          <DimensionsProvider value={dimensions}>
            <ImageSection hovered={hovered} variant={variant} />
          </DimensionsProvider>
        )}
      </Dimensions>
    );
  }

  function renderOther() {
    if (isTextOnly(content)) {
      return <ContentSection enableMenu variant={variant} />;
    }

    return (
      <Fragment>
        {renderImageSection()}
        <ContentSection variant={variant} />
      </Fragment>
    );
  }

  function renderLarge() {
    if (isTextOnly(content)) {
      return (
        <Grid container>
          <Grid xs={12}>
            <ContentSection enableMenu variant={variant} />
          </Grid>
        </Grid>
      );
    }

    if (!isLargeScreen) {
      return (
        <Grid container spacing={3}>
          <Grid xs={12}>{renderImageSection()}</Grid>
          <Grid xs={12}>
            <ContentSection variant={variant} />
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid container>
        <Grid xs={6}>
          <ContentSection newLineActions variant={variant} />
        </Grid>
        <Grid xs={6}>{renderImageSection()}</Grid>
      </Grid>
    );
  }

  return (
    <ContentProvider value={content}>
      <Paper
        elevation={1}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {variant !== GridLayoutSizes.Large && renderOther()}
        {variant === GridLayoutSizes.Large && renderLarge()}
      </Paper>
    </ContentProvider>
  );
};

export default FeedGridItem;
